import React from 'react'
import { FaPhoneAlt, FaMailBulk, FaLocationArrow  } from 'react-icons/fa';

export const ContactThreeBox = () => {
  return (
      <section className='contact-three-box p-top'>
           <div className="container">
                <div className="flex">
                        <div className="box">
                              <ul>
                                  <li><span> <FaPhoneAlt/></span></li>
                                  <li><h3>Contact Number</h3></li>
                                  <li><p>A wonderful serenity has taken possession of my entire soul, like these.</p></li>
                                  <li><a href="/">+1(856) 888-9026</a></li>
                              </ul>
                        </div>
                        <div className="box">
                              <ul>
                              <li><span> <FaMailBulk/></span></li>
                                  <li><h3>Official Email</h3></li>
                                  <li><p>A wonderful serenity has taken possession of my entire soul, like these.</p></li>
                                  <li><a href="/">info@techsaga.co.in</a></li>
                              </ul>
                        </div>
                        <div className="box">
                              <ul>
                                  <li><span> <FaLocationArrow/></span></li>
                                  <li><h3>Our Location</h3></li>
                                  <li><p>A wonderful serenity has taken possession of my entire soul, like these.</p></li>
                                  <li><a href="/">Check Location</a></li>
                              </ul>
                        </div>
                </div>
           </div>
      </section>
  )
}

                           
